import lang from '@/lang/middleware/products/mortgage';
import { getProviderWithMortgages } from '@/graphql/queries/shared/institution';

export default async ({ $apolloQuery, app, redirect, route, store }) => {
  await $apolloQuery(getProviderWithMortgages, { slug: route.params.provider }).then(provider => {
    store.$i18n.mergeLocaleMessage('en', lang.en);
    const description = store.$i18n.t('lender.description', { lender: provider.name });
    const title = store.$i18n.t('lender.title', { lender: provider.name });
    store.commit('pageContent/setHead', { title, description });
    store.commit('pageContent/SET_DYNAMIC_BREADCRUMBS', [
      ['i18n/banking', '/money/'], ['i18n/mortgages', '/compare-mortgages/'],
      ['i18n/mortgage-lenders', '/compare-mortgages/lenders/', 'mobile'], provider.name
    ]);
    store.commit('blog/setList', provider.articles);
    store.commit('products/setList', provider.mortgages);
    delete provider.articles;
    delete provider.mortgages;
    store.commit('jumbotron/SET_JUMBOTRON', { extra: 'site-jumbotron-pricechange', title, type: 'generic' });
    store.commit('providers/set', provider);
  }).catch(_ => {
    redirect(301,
      app.localePath('/compare-mortgages/'),
      { flashClass: 'error', flashMessage: store.$i18n.t('errors.providerNotFound', [route.params.provider]) });
  });
};
